<template>
    <div class="horizontal-feed-wrapper" v-if="show" v-cloak>
        <div class="row">
            <div class="column">
                <div class="horizontal-feed">
                    <div class="header"><span v-text="heading"></span></div>
                    <div class="body" :class="swappingClass" @mouseover="pause" @mouseout="resume">
                        <div>
                            <p v-for="(item, index) in items" :class="activeClass(index)">
                                <a :href="item.url" v-text="item.title"></a> <span v-text="item.body"></span>
                            </p>
                        </div>
                        <div class="cover"></div>
                    </div>
                    <div class="buttons">
                        <span class="previous" @click="goPrevious"><i class="fas fa-angle-left"></i></span>
                        <span class="play" @click="play" :class="playClass"><i class="fas fa-play"></i></span>
                        <span class="next" @click="goNext"><i class="fas fa-angle-right"></i></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            duration: {
                type: Number,
                default: 7000
            },
            collection: {
                type: [Object, Array, String],
                default: () => { return {} }
            }
        },
        data() {
            return {
                heading: 'Announcements',
                items: [],
                max: 0,
                show: false,
                current: 0,
                interval: null,
                paused: false,
                swapping: false
            };
        },
        computed: {
            swappingClass() {
                return {
                    'swapping' : this.swapping
                }
            },
            playClass() {
                return {
                    'active' : !this.interval
                }
            }
        },
        mounted() {
            if (this.duration <= 2000) {
                throw new Error('Duration must be higher than 2000');
            }
            if (typeof this.collection === 'string') {
                this.getItems();
            } else {
                this.items = this.collection.list;
                this.initialise();
            }
        },
        methods: {
            initialise() {
                if (this.items.length === 0) {
                    return;
                }
                this.max = this.items.length - 1;
                this.show = true;
                this.swap();
            },
            getItems() {
                if (this.collection === '') {
                    throw new Error('Invalid end point');
                }
                axios.get(this.collection)
                    .then(this.fetchSuccess)
                    .catch(this.fetchError);
            },
            fetchSuccess(response) {
                if (response.data.heading) {
                    this.heading = response.data.heading;
                }
                this.items = response.data.list;
                this.initialise();
            },
            fetchError(error) {
                throw new Error(error);
            },
            activeClass(index) {
                return {
                    'active' : index === this.current
                }
            },
            swap() {
                this.interval = setInterval(() => {
                    if (!this.paused) {
                        this.nextSlide();
                    }
                }, this.duration);
            },
            progress(direction) {
                this.swapping = true;
                setTimeout(() => {
                    this.current = this[direction]();
                    this.swapping = false;
                }, 1000);
            },
            nextSlide() {
                this.progress('next');
            },
            next() {
                if (this.current === this.max) {
                    return 0;
                }
                return this.current + 1;
            },
            previousSlide() {
                this.progress('previous');
            },
            previous() {
                if (this.current === 0) {
                    return this.max;
                }
                return this.current - 1;
            },
            goPrevious() {
                this.stop();
                this.previousSlide();
            },
            goNext() {
                this.stop();
                this.nextSlide();
            },
            stop() {
                clearInterval(this.interval);
                this.interval = null;
            },
            pause() {
                this.paused = true;
            },
            resume() {
                this.paused = false;
            },
            play() {
                if (this.interval) {
                    return;
                }
                this.swap();
            }
        }
    };
</script>